import { render, staticRenderFns } from "./Holes.vue?vue&type=template&id=815a016a&"
import script from "./Holes.vue?vue&type=script&lang=js&"
export * from "./Holes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports